

export const dark = {
    body: '#202020',
    text: '#ffffff',
    bodyRgba: '32,32,32',
    textRgba: '255,255,255',

    grey: '#bebebe',

    frontxs: '0.75em',
    frontsm: '0.875em',
    frontmd: '1em',
    frontlg: '1.25em',
    frontxl: '2em',
    frontxxl: '3em',
    frontxxxl: '5em',
    frontBig: '10em',


    navHeight: '2.5rem'



}
